<template>
  <v-container fluid class="px-0 pt-0">
    <Loading v-if="isLoading"/>
    <div>
      <v-simple-table v-dragscroll.x class="table-full no-topbar dragscroll" :fixed-header= "true">
        <thead>
          <tr>
            <th rowspan="3">{{$t('Register date')}}</th>
            <th rowspan="3">Maj</th>
            <th rowspan="3">{{$t('Return to school')}}</th>
            <th rowspan="3">
              Sources
              <SourceFilterInput @change="fetch" v-model="filters.source.value"></SourceFilterInput>
            </th>
            <th colspan="8" class="border-col">Consentements</th>
            <th rowspan="3">
              Alternance
              <AlternanceFilterInput @change="fetch" v-model="filters.isAlternance.value"></AlternanceFilterInput>
            </th>
<!--            <th rowspan="3">Gratuit/ Payant</th>-->
            <th rowspan="3">
              Niveau
              <StudyLevelFilterInput @change="fetch" v-model="filters.studyLevels.value"></StudyLevelFilterInput>
            </th>
            <th rowspan="3">
              Type Diplôme
              <DiplomaFilterInput @change="fetch" v-model="filters.diplomas.value"></DiplomaFilterInput>
            </th>
            <th rowspan="3">Nom du Diplôme</th>
            <th rowspan="3" style="min-width: 250px;">Spécialité(s) étudiée(s)</th>
            <th rowspan="3" style="min-width: 250px;">Thème 1</th>
            <th rowspan="3" style="min-width: 250px;">Thème 2</th>
            <th colspan="4" rowspan="2" class="border-col">Choix de poursuite d'études</th>
            <th rowspan="3">Pays</th>
            <th rowspan="3">CP</th>
            <th rowspan="3">Ville</th>
            <th rowspan="3">{{$t('Region')}}</th>
            <th rowspan="3">{{$t('Department')}}</th>
            <th rowspan="3">{{$t('Gender')}}</th>
            <th rowspan="3">
                Nom <br/>
                <v-text-field
                v-if="canDisplaySearch"
                label="Rechercher"
                @keyup.enter.native="fetch"
                v-model="filters.lastName.value"
              ></v-text-field>
            </th>
            <th rowspan="3">
                  Prénom <br/>
              <v-text-field
                v-if="canDisplaySearch"
                label="Rechercher"
                @keyup.enter.native="fetch"
                v-model="filters.firstName.value"
              ></v-text-field>
            </th>
            <th rowspan="3">
              Délégué
              <DelegateFilterInput @change="fetch" v-model="filters.delegate.value"></DelegateFilterInput>
            </th>
            <th rowspan="3">{{$t('DOB')}}</th>
            <th colspan="6" rowspan="2" class="border-col">CANAL</th>
            <th rowspan="3" class="border-col" style="min-width: 250px">Adresse postale</th>
          </tr>
          <tr>
            <th colspan="4" class="border-col">Eduniversal</th>
            <th colspan="4" class="border-col">Partenaire</th>
          </tr>
          <tr>
            <th class="border-left">Email</th>
            <th>Appel Téléphonique</th>
            <th>SMS</th>
            <th class="border-right">Whatsapp</th>
            <th class="border-left">Email</th>
            <th>Appel Téléphonique</th>
            <th>SMS</th>
            <th class="border-right">Whatsapp</th>
            <th class="border-left" style="min-width: 250px;">Spécialité 1</th>
            <th class="border-left" style="min-width: 250px;">Spécialité 2</th>
            <th class="border-right" style="min-width: 250px;">Spécialité 3</th>
            <th class="border-right">Plus</th>
            <th class="border-left" style="min-width: 150px">{{$t('Telephone')}}<br/>
              <v-text-field
                v-if="canDisplaySearch"
                label="Rechercher"
                @keyup.enter.native="fetch"
                v-model="filters.phone.value"
              ></v-text-field>
            </th>
            <th style="min-width: 200px">
              Email <br/>
              <v-text-field
                v-if="canDisplaySearch"
                label="Rechercher"
                @keyup.enter.native="fetch"
                v-model="filters.email.value"
              ></v-text-field>
            </th>
            <th>{{$t('Postal')}}</th>
            <th>Push Notif App</th>
            <th>Push Notif Navigateur</th>
            <th class="border-right">FB Message</th>
            <th rowspan="2" v-if="canDelete"></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.registeredAt | moment('DD/MM/YYYY')}}</td>
            <td>{{ item.updatedAt | moment('DD/MM/YYYY')}}</td>
            <td>
              <span v-if="Number(item.yearBackToSchool)">
                {{ Number(item.yearBackToSchool) + 1 }}
              </span>
              <span v-else>

              </span>
            </td>
            <td style="white-space: nowrap;">{{ item.source}}</td>
            <td>
              <span v-if="item.eduniversalEmail != 0 && item.eduniversalEmail != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.eduniversalPhone != 0 && item.eduniversalPhone != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.eduniversalSms != 0 && item.eduniversalSms != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.eduniversalWhatsapp != 0 && item.eduniversalWhatsapp != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.partnerEmail != 0 && item.partnerEmail != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.partnerPhone != 0 && item.partnerPhone != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.partnerSms != 0 && item.partnerSms != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.partnerWhatsapp != 0 && item.partnerWhatsapp != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.isAlternance == 1" class="caption"><i class="fas fa-circle"></i></span>
              <span v-else-if="item.isAlternance == 0" class="caption" v-else><i class="fal fa-circle"></i></span>
              <span v-else>-</span>
            </td>
<!--            <td>{{ item.isPaid ? 'Payant' : 'Gratuit' }}</td>-->
            <td>{{ item.studyLevel }}</td>
            <td>{{ item.diplomaName }}</td>
            <td>{{ item.obtainedMajorName }}</td>
            <td v-html="transformObtainedSpecialityName(item.obtainedSpecialities)"></td>
            <td :key="`${indexObjective}_a`" v-for="(objective, indexObjective) in functionfetchArr(item.themes ,2)">
                {{ objective }}
            </td>
            <td :key="`${indexObjective}_b`" v-for="(objective, indexObjective) in functionfetchWithMoreArr(item.objectiveSpecialities ,3)">
                {{ objective }}
            </td>
            <td>{{ item.country }}</td>
            <td>{{ item.postalCode }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.region }}</td>
            <td>{{ item.department }}</td>
            <td>{{ item.gender | gender}}</td>
            <td>{{ item.lastName }}</td>
            <td>{{ item.firstName }}</td>
            <td>
              <span v-if="item.delegate != 0 && item.delegate != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>{{ item.dob | moment('DD/MM/YYYY') }}</td>
            <td>{{ item.phone }}</td>
            <td>
              {{ item.email }}
            </td>
            <td>
              <span v-if="item.postalCode && item.address" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.pushApp != 0 && item.pushApp != null" class="caption"><i class="fas fa-circle"></i></span>
              <span class="caption" v-else><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.pushBrowser != 0 && item.pushBrowser != null" class="caption"><i class="fas fa-circle"></i></span>
                <span v-else class="caption"><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-if="item.fbMessage" class="caption"><i class="fas fa-circle"></i></span>
                <span v-else class="caption"><i class="fal fa-circle"></i></span>
            </td>
            <td>
              <span v-html="transformAddress(item.address)"></span>
            </td>
            <td v-if="canDelete">
              <v-btn icon :ripple="false" color="blue" v-if="canEdit" @click="showEdit(item)">
                  <i class="fas fa-edit" title="Modifier" />
              </v-btn>

              <v-btn icon :ripple="false" color="green" v-if="canEdit && hiddenFeaturesEnabled" @click="showForward(item)">
                  <i class="fas fa-paper-plane" title="Forward to Brevo" />
              </v-btn>

              <v-btn icon :ripple="false" color="red" @click="showDelete(item)">
                  <i class="fas fa-trash-alt red--text" title="Supprimer" />
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <div class="mt-4 mb-1 mx-4" v-if="items.length > 0">
        <div class="d-flex align-center">
          <span class="mr-4">Affichage</span>
          <v-select
            v-model="limit"
            :items="itemPerPageList"
            hide-details
            dense
            outlined
            style="max-width: 90px"
          ></v-select>
          <span class="ml-4 mr-2">sur {{ totalItems }} items par page</span>
          <v-pagination class="justify-start" v-model="page" :length="totalPage" :total-visible="10"></v-pagination>
        </div>
      </div>
    </div>

    <v-dialog
        v-model="deleteModal.show"
        width="500"
    >
      <v-card>
        <v-card-title
            class="py-3 grey lighten-2"
            primary-title
        >
          <img src="assets/img/logo-long.png" alt=""  height="35" class="mx-auto">
        </v-card-title>

        <v-card-text class="py-4">
          <p class="text-center">{{ deleteModal.message }}</p>

          <div class="pt-2 text-center">
            <v-btn color="primary" :loading="isLoading" @click="confirmRemove()">D'accord</v-btn>
            <v-btn
                class="ma-2"
                outlined
                color="indigo"
                @click="deleteModal.show = false"
            >
              Annuler
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="forwardModal.show"
        width="500"
    >
      <v-card>
        <v-card-title
            class="py-3 grey lighten-2"
            primary-title
        >
          <img src="assets/img/logo-long.png" alt=""  height="35" class="mx-auto">
        </v-card-title>

        <v-card-text class="py-4">
          <p class="text-center">{{ forwardModal.message }}</p>
          <p class="text-center" v-if="forwardModal.item">
            <strong>{{ forwardModal.item.firstName }} {{ forwardModal.item.lastName }}</strong>
            <span v-if="forwardModal.item.email"> — {{ forwardModal.item.email }}</span>
          </p>

          <div class="pt-2 text-center">
            <v-btn color="primary" :loading="isLoading" @click="confirmForward()">D'accord</v-btn>
            <v-btn
                class="ma-2"
                outlined
                color="indigo"
                @click="forwardModal.show = false"
            >
              Annuler
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="editModal.show"
        width="500"
    >
      <v-card>
        <v-card-title
            class="py-3 grey lighten-2"
            primary-title
        >
          <img src="assets/img/logo-long.png" alt=""  height="35" class="mx-auto">
        </v-card-title>

        <v-card-text class="py-4">
          <p class="text-center">{{ editModal.message }}</p>

          <v-form
            ref="form"
            lazy-validation
          >
            <v-text-field
              v-model="editModal.student.firstName"
              label="Prénom"
            ></v-text-field>

            <v-text-field
              v-model="editModal.student.lastName"
              label="Nom"
            ></v-text-field>

            <v-text-field
              v-model="editModal.student.email"
              label="Email"
              required
            ></v-text-field>

            <v-text-field
              v-model="editModal.student.phone"
              label="Téléphone"
            ></v-text-field>

            <v-text-field
              v-model="editModal.student.dob"
              label="Date de naissance"
              ref="dob"
              placeholder="jj/mm/aaaa"
              @input="restrictDate($event)"
            ></v-text-field>

            <v-text-field
              v-for="(address, index) in editModal.addresses"
              :key="index"
              v-model="editModal.addresses[index]"
              :label="`Adresse postale ` + (index + 1)"
            ></v-text-field>
          </v-form>

          <div class="pt-2 text-center">
            <v-btn color="primary" @click="updateStudent()" :loading="isLoading">Enregistrer</v-btn>
            <v-btn
                class="ma-2"
                outlined
                color="indigo"
                @click="closeEdit()"
            >
              Annuler
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import { mapState } from 'vuex';
import DatabaseService from '../../services/database.service';
import Loading from '../../components/Loading.vue';
import SourceFilterInput from '@/components/inputs/SourceFilterInput.vue';
import DelegateFilterInput from '@/components/inputs/DelegateFilterInput.vue';
import StudyLevelFilterInput from '@/components/inputs/StudyLevelFilterInput.vue';
import DiplomaFilterInput from '@/components/inputs/DiplomaFilterInput.vue';
import AlternanceFilterInput from '@/components/inputs/AlternanceFilterInput.vue';
import { dragscroll } from 'vue-dragscroll';
import StringUtil from '../../utils/string.util';

export default {

  name: "Databases",
  directives: {
    dragscroll
  },
  data: () => ({
    page: 1,
    totalPage: 1,
    items: [],
    limit: 50,
    totalItems: 0,
    isLoading: false,
    emailSearch: null,
    canDisplaySearch: false,
    canDelete: false,
    deleteModal: {
      show: false,
      title: "Confirmation de la suppression ?",
      message: "Les données supprimées ne peuvent pas être restaurées !",
      item: null,
    },
    canEdit: false,
    forwardModal: {
      show: false,
      message: "Voulez-vous transférer cet étudiant vers Brevo ?",
      item: null,
    },
    editModal: {
      show: false,
      title: "",
      message: "",
      formattedDob: null,
      item: null,
      addresses: [],
      student: {
        id: null,
        email: null,
        phone: null,
        firstName: null,
        lastName: null,
        address: null,
        dob: null,
      },
    },
    filters: {
      'source': {
        'field': 'source',
        'value': []
      },
      'delegate': {
        'field': 'delegate',
        'value': []
      },
      email: {
        'field': 'email',
        'value': null,
      },
      phone: {
        'field': 'phone',
        'value': null,
      },
      firstName: {
        'field': 'firstName',
        'value': null,
      },
      lastName: {
        'field': 'lastName',
        'value': null,
      },
      studyLevels: {
        'field': 'studyLevels',
        'value': []
      },
      diplomas: {
        'field': 'diplomas',
        'value': []
      },
      isAlternance: {
        'field': 'isAlternance',
        'value': []
      }
    }
  }),
  components: {
    Loading,
    SourceFilterInput,
    DelegateFilterInput,
    StudyLevelFilterInput,
    DiplomaFilterInput,
    AlternanceFilterInput
  },
  computed: {
   ...mapState({
      itemPerPageList: state => state.pagination.itemPerPageList,
      itemPerPage: state => state.pagination.itemPerPage
    }),
    hiddenFeaturesEnabled() {
      return this.$route.query.hiddenFeatures === '1';
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));

    console.log(user);

    if (user.roles.includes("ROLE_ADMIN_SUPPER") || user.roles.includes("ROLE_ADMIN")) {
      this.canDisplaySearch = true;
      this.canDelete = true;
      this.canEdit = true;
    }
  },
  methods: {
    transformObtainedSpecialityName(strListName) {
      if (!strListName) {
        return;
      }

      const arr = strListName.split('|| ').map(item => `&bull; ${item.charAt(0).toUpperCase() + item.slice(1)}.`);
      return arr.join("<br />");
    },
    transformAddress(addressString) {
      if (!addressString) {
        return;
      }

      let addresses = addressString.split('|');

      if (addresses.length <= 1) {
        return addresses[0];
      }

      const arr = addresses.map(item => `&bull; ${item.charAt(0).toUpperCase() + item.slice(1)}`);
      return arr.join("<br />");
    },
    functionfetchWithMoreArr(item , maxlength) {
      let arr = (item || '').split('|| ');

      let tds = [];

      tds = arr.slice(0, Math.min(arr.length, maxlength));

      if (tds.length < maxlength) {
        for (let i = tds.length; i < maxlength; ++i) {
          tds.push('');
        }
      }

      // Push +more item
      if (arr.length > maxlength) {
        tds.push(`+ ${arr.length - maxlength}`);
      } else {
        tds.push('');
      }

      return tds;
    },
    functionfetchArr(item , maxlength) {
      let arr = (item || '').split('|| ');
      if(arr.length < maxlength) {
        for (let i = arr.length + 1; i <= maxlength; i++)  {
          arr.push('');
        }
      }
      if(arr.length > maxlength){
         arr = arr.slice(0, maxlength);
      }
      return arr;
    },
    showEdit(item) {
      if (!item) {
        return false;
      }

      this.editModal.item = item;
      this.editModal.addresses = item.address ? StringUtil.parseAddress(item.address) : '';

      this.editModal.student.id = item.id;
      this.editModal.student.firstName = item.firstName;
      this.editModal.student.lastName = item.lastName;
      this.editModal.student.email = item.email;
      this.editModal.student.phone = item.phone;
      this.editModal.student.dob = (item.dob !== null && item.dob.length > 0) ? this.$moment(item.dob).format('DD/MM/YYYY') : null;

      this.editModal.formattedDob = this.editModal.student.dob;
      this.editModal.show = true;
    },
    showDelete (item) {
      if (!item) {
        return false;
      }

      this.deleteModal.item = item;
      this.deleteModal.show = true;
    },
    showForward (item) {
      if (!item) {
        return false;
      }

      this.forwardModal.item = item;
      this.forwardModal.show = true;
    },
    async confirmForward () {
      const item = this.forwardModal.item;

      if (!item) {
        return false;
      }

      this.isLoading = true;

      try {
        const response = await DatabaseService.forwardToBrevo(item.id);
        const result = response.data.result;

        if (result && result.status === 'sent') {
          this.successMessage(`Étudiant transféré vers Brevo (liste ${result.listId}).`);
        } else if (result && result.status === 'skipped') {
          this.errorMessage(`Non transféré : ${result.reason}.`);
        } else if (result && result.status === 'failed') {
          this.errorMessage(`Échec du transfert : ${result.reason}.`);
        } else {
          this.errorMessage('Réponse inattendue du serveur.');
        }

        this.forwardModal.show = false;
      } catch (e) {
        this.handleError(e);
      }

      this.isLoading = false;
    },
    deleteStudent() {
      let response = DatabaseService.remove(studentId);

      console.log(response);
    },
    async updateStudent() {
      if (this.editModal.student.id == null) {
        return false;
      }
      this.editModal.student.address = StringUtil.cleanAddress(this.editModal.addresses.join('|'));

      this.isLoading = true;

      try {
        const response = await DatabaseService.update(this.editModal.student.id, this.editModal.student);

        if (response.data.status === 'success') {
          this.editModal.show = false;

          this.updateItem();
          // this.cleanEditModal();
        }
      } catch (e) {
        this.handleError(e);
      }

      this.isLoading = false;
    },
    async confirmRemove () {
      let deletedItem = this.deleteModal.item;

      if (deletedItem === null) {
        return false;
      }

      this.isLoading = true;

      try {
        let response = await DatabaseService.remove(deletedItem.id);

        if (response.data.status === 'success') {
          let rowIndex = this.items.indexOf(deletedItem);

          this.items.splice(rowIndex, 1);

          this.deleteModal.show = false;
          this.deleteModal.item = null;
        }
      } catch (e) {
        this.handleError(e);
      }

      this.isLoading = false;
    },
    async fetch(cb = null) {
      this.isLoading = true;
      try {
        const response = await DatabaseService.getPagedResult(
          {
            page: this.page,
            limit: this.limit,
            filters: this.filters
          }
        );
        this.items = response.data.data;
        this.totalItems = response.data.total;
        this.totalPage = response.data.totalPage;
        if (typeof (cb) === 'function') {
          cb();
        }
      } catch (e) {
        this.$notification.error(e.response.data.error.message);
      }
      this.isLoading = false;
    },
    updateItem () {
      let updatedItem = this.editModal.item;

      updatedItem.firstName = this.editModal.student.firstName;
      updatedItem.lastName = this.editModal.student.lastName;
      updatedItem.email = this.editModal.student.email;
      updatedItem.phone = this.editModal.student.phone;
      updatedItem.dob = this.parseDate(this.editModal.student.dob);
      updatedItem.address = this.editModal.student.address;
    },
    closeEdit() {
      this.editModal.show = false;
      this.cleanEditModal();
    },
    cleanEditModal() {
      this.editModal.item = null;
      this.editModal.formattedDob = null;
      this.editModal.student.firstName = null;
      this.editModal.student.lastName = null;
      this.editModal.student.email = null;
      this.editModal.student.phone = null;
      this.editModal.student.dob = null;
      this.editModal.student.address = null;
    },
    parseDate (date) {
      if (!date) return null;

      const [day, month, year] = date.split('/');

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    checkValue(str, max) {
      if (str.charAt(0) !== '0' || str == '00') {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
      };
      return str;
    },
    restrictDate(e) {
      var input = this.editModal.student.dob;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function(v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = this.checkValue(values[0], 31);
      if (values[1]) values[1] = this.checkValue(values[1], 12);
      var output = values.map(function(v, i) {
        return v.length == 2 && i < 2 ? v + '/' : v;
      });
      this.editModal.student.dob = output.join('').substr(0, 14);
    },
  },
  watch:{
    page(item){
        this.page = item;
        this.fetch();
    },
    limit(item){
        this.fetch();
    }
  }
};
</script>

